import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SearchencodeService } from '../searchencode/searchencode.service';

@Injectable({
  providedIn: 'root'
})
export class VideoService {
  private API_URL = environment.API_URL;
  constructor(private http: HttpClient) { }

  getAllVideosCount(){   
    return this.http.get(`${this.API_URL}/ImmortalAdmin/GetAllVideosCount`, {     
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        // "Authorization":"Bearer " +localStorage.getItem("token") 
     }),
    })
  }

  GetAllUserMemoriesVideoCount(){   
    return this.http.get(`${this.API_URL}/ImmortalAdmin/ GetAllUserMemoriesVideoCount`, {     
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        // "Authorization":"Bearer " +localStorage.getItem("token") 
     }),
    })
  }

  GetAllUserMemoriesVideoCountListWithPagination(paramsReq:any): Observable<any> {    
       let params = new HttpParams({ encoder: new SearchencodeService() })
          .set('PageNumber', paramsReq.PageNumber)
          .set('PageSize', paramsReq.PageSize)       
          .set('SortBy', paramsReq.SortBy)
          .set('sortColumn', paramsReq.sortColumn);
          if (paramsReq.searchTerm) {
           params = params.append('searchTerm', paramsReq.searchTerm);
         }
        return this.http.get(`${this.API_URL}/ImmortalAdmin/GetAllUsersVideoCountListWithPagination`, {     
            headers: new HttpHeaders({
              "Content-Type": "application/json",
            //  Authorization: "Bearer " + localStorage.getItem("token"),
            }),
            params: params,
          })
      }
}
